import { combineReducers } from 'redux';
import notifications from './notificationReducer';
import organisation from './organisationReducer';
import loggedInUser from './userReducer';
import signup from './signupReducer';
import billing from './billingReducer';
import stripe from './stripeReducer';
import trainingGround from './trainingGroundReducer';
import contentList from './contentListReducer';
import content from './contentReducer';
import session from './sessionReducer';
import diagram from './diagramReducer';
import comments from './commentReducer';
import metadata from './metadataReducer';
import favourited from './favouriteReducer';
import reported from './reportReducer';
import doIFollow from './followReducer';
import access from './accessReducer';
import shareCount from './shareReducer';
import folders from './folderReducer';
import images from './imageReducer';
import licences from './licenceReducer';
import search from './searchReducer';

const rootReducer = combineReducers({
  notifications,
  organisation,
  loggedInUser,
  signup,
  billing,
  stripe,
  trainingGround,
  access,
  contentList,
  content,
  session,
  diagram,
  comments,
  metadata,
  favourited,
  reported,
  doIFollow,
  shareCount,
  folders,
  images,
  licences,
  search,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./library/app/reducers/index.js